import React from 'react';
import { Link } from 'react-router-dom';
import AiToolWrapper from '../components/AiToolWrapper';

// ★ IMPORT THE NEW CONTROL CARTRIDGE ★
import BlurBgControls from '../components/ToolEngine/Controls/BlurBgControls';

// Use specific CSS for this page
import './BlurBgPage.css';

export default function BlurBgPage({ session }) {

  // SEO Schema
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "FullMockup AI Background Blur",
    "applicationCategory": "DesignApplication",
    "operatingSystem": "Web Browser",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
    "description": "Professional AI tool to apply natural background blur (bokeh) to images.",
    "featureList": "Automatic subject detection, Adjustable blur intensity"
  };

  return (
    <div className="blur-bg-page fade-in">
      {/* Inject SEO */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      {/* --- A. HEADER --- */}
      <header className="blur-page-header">
        <h1>AI Background Blur</h1>
        <p>Turn any photo into a professional portrait. Our AI automatically handles the subject detection so you can create the perfect bokeh effect.</p>
      </header>

      {/* --- B. WORKSPACE (Using the New Engine) --- */}
      <div className="blur-workspace-container">
        <AiToolWrapper 
          title="Blur Background"
          apiEndpoint="/api/tools/blur-background"
          
          // ★ THE NEW SLIDER CONTROLS ★
          SettingsFormComponent={BlurBgControls}
          
          session={session} 
          actionName="Apply Blur"
          layoutVariant="slider"
        />
      </div>

      {/* --- C. SEO & FAQ SECTION --- */}
      <section className="tool-seo-section">
        <div className="seo-content-block">
          <h2>What is FullMockup's Background Blur Tool?</h2>
          <p>
            FullMockup's <strong>AI Background Blur</strong> uses advanced computer vision to separate the foreground from the background. By applying an intelligent Gaussian blur, it simulates a high-end DSLR depth-of-field effect.
          </p>
        </div>

        <div className="tool-faq-grid">
          <div className="faq-card">
            <div className="icon-box"><i className="bi bi-camera"></i></div>
            <h3>DSLR Quality?</h3>
            <p>Yes. The blur algorithm mimics real lens optics (bokeh) rather than a simple flat blur.</p>
          </div>
          
          <div className="faq-card">
            <div className="icon-box"><i className="bi bi-sliders"></i></div>
            <h3>Adjustable?</h3>
            <p>Fully. Use the slider to go from a subtle portrait effect to a creamy, abstract background.</p>
          </div>

          <div className="faq-card">
            <div className="icon-box"><i className="bi bi-shield-lock"></i></div>
            <h3>Is it private?</h3>
            <p>100%. Images are processed securely and deleted after 24 hours.</p>
          </div>
        </div>
      </section>

    </div>
  );
}